import React from "react";
// * Styles
import {
  Container,
  Truck,
  IconSection,
  Text,
  Support,
  Guarantee,
  IconWrapper,
} from "./AboveFooter.elements";

const AboveFooter = () => {
  return (
    <Container>
      <IconSection>
        <IconWrapper>
          <Truck />
          <Text>ارسال رایگان</Text>
        </IconWrapper>
        <IconWrapper>
          <Guarantee />
          <Text>ضمانت محصول</Text>
        </IconWrapper>
        <IconWrapper>
          <Support />
          <Text>پشتیبانی آنلاین</Text>
        </IconWrapper>
      </IconSection>
    </Container>
  );
};

export default AboveFooter;
